/**
 * RESPONSIBILITY: where a link to one event goes.
 *
 * `#events/men/mens-breakfast` — the tag it already carries, then the event. The tag is
 * existing data, so this cost no new field: an event is filed under something, and the
 * URL says what.
 *
 * An event with SEVERAL tags is filed under its first. That is arbitrary and deliberate:
 * one event needs one address, or the same page has two URLs and neither is canonical.
 * An untagged event has no category to sit under, so it keeps the flat `#event/<slug>`
 * form rather than growing an empty segment.
 *
 * Resolution never depends on the category being right — the event is found by its last
 * segment alone — so re-tagging an event changes its link without breaking the old one.
 */
import type { EventRow } from '@app/sections';
import { Page, hrefFor } from '../commons/pages';
import { keyOf, slugify } from '../commons/slug';

export function eventHref(e: EventRow): string {
  const tag = e.categories?.[0];
  return tag
    ? hrefFor(Page.Events, slugify(tag), keyOf(e))
    : hrefFor(Page.Event, keyOf(e));
}
